import React from 'react';
import classes from './AuditScreen.module.css';
import Card from './Card/Card';
import { Table, Tag, Space ,Pagination} from 'antd';
import button from '../../Auth/button';
import { Button as AntButton } from "antd";
import { useHistory } from 'react-router';
const { Column, ColumnGroup } = Table;
const data = [
  {
    key: '1',
    firstName: 'John',
    lastName: 'Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: ['Completed'],
  },
  {
    key: '2',
    firstName: 'Jim',
    lastName: 'Green',
    age: 42,
    address: 'London No. 1 Lake Park',
    tags: ['Pendind'],
  },
  {
    key: '3',
    firstName: 'Joe',
    lastName: 'Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    tags: ['Completed'],
  },
  {
    key: '4',
    firstName: 'Joe',
    lastName: 'Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    tags: ['Completed'],
  },
  {
    key: '5',
    firstName: 'Joe',
    lastName: 'Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    tags: ['Completed']
  },
  {
    key: '5',
    firstName: 'Joe',
    lastName: 'Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    tags: ['Completed']
  }
];


const Audit=()=>{
    const history=useHistory()
    const newInspection=()=>{
        history.push('/newInspection')
    }

    return(
        <div>
            <div className={classes.newInspection}>
            <h2>Audits</h2>
            <AntButton 
            onClick={newInspection}
            className={[classes.controlBtn, classes.saveBtn].join(" ")}>
            New Inspection</AntButton>
            </div>
            <hr />
            <div className={classes.cards}>
                <Card data={6}><div className={classes.cardText} >Total Audits Conducted</div></Card>
                <Card data={5}> <span className={classes.cardText} >Completed</span></Card>
                <Card data={1}><span className={classes.cardText}>Pendind</span></Card>
            </div>
            <div className={classes.table}>
                
  <Table dataSource={data} defaultCurrent={6} total={500} >
   
      <Column title="First Name" dataIndex="firstName" key="firstName" />
      <Column title="Last Name" dataIndex="lastName" key="lastName" />
    <Column title="Age" dataIndex="age" key="age" />
    <Column title="Address" dataIndex="address" key="address" />
    <Column
      title="Status"
      dataIndex="tags"
      key="tags"
      render={tags => (
        <>
          {tags.map(tag => (
            <Tag color="blue" key={tag}>
              {tag}
            </Tag>
          ))}
        </>
      )}
    />
    <Column
      title="Action"
      key="action"
      render={(text, record) => (
        <Space size="middle">
          <a>Inspect </a>
          <a>Download</a>
        </Space>
      )}
    />
    <Pagination defaultCurrent={6} total={500} />
  </Table>
            </div>
        </div>
    )


}


export default Audit;